import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  public isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  readonly #message = signal<string>('');

  /** Message shown inside the overlay while a request is in flight. */
  readonly message = this.#message.asReadonly();

  /** Monotonic id of the message currently owning the overlay. */
  #token = 0;

  /**
   * Sets the overlay message and returns a token identifying this message.
   * Pass the token back to clearMessage so a late cleanup cannot wipe a newer
   * message — chained calls set the next message before the previous request's
   * finalize runs.
   */
  setMessage(message: string): number {
    this.#token += 1;
    this.#message.set(message);
    return this.#token;
  }

  /**
   * Clears the message only if the token still owns it. Called without a token
   * it force-clears, for teardown.
   */
  clearMessage(token?: number): void {
    if (token !== undefined && token !== this.#token) {
      return;
    }
    this.#message.set('');
  }
}
